(() => {
  const updateLayout = () => {
    // 1. 将 Most Recent 排序下拉与 Write a review 统一打包进右侧操作栏，确保严格同处一行
    const headers = document.querySelectorAll(
      '.ng-pdp-reviews-section .jdgm-rev-widg__header, .ng-product-reviews .jdgm-rev-widg__header'
    );
    headers.forEach((header) => {
      let toolbar = header.querySelector('.ng-rev-actions-toolbar');
      const sort = header.querySelector('.jdgm-rev-widg__sort-wrapper');
      const write = header.querySelector('.jdgm-write-rev-link');
      if (sort && write) {
        if (!toolbar) {
          toolbar = document.createElement('div');
          toolbar.className = 'ng-rev-actions-toolbar';
          header.appendChild(toolbar);
        }
        if (sort.parentElement !== toolbar) toolbar.appendChild(sort);
        if (write.parentElement !== toolbar) toolbar.appendChild(write);
      }
    });

    // 2. 评论卡片网格布局：将首字母头像移至评价卡片根级首项，确保姓名与正文在右列垂直左对齐
    const reviews = document.querySelectorAll(
      '.ng-pdp-reviews-section .jdgm-rev, .ng-product-reviews .jdgm-rev'
    );
    if (!reviews.length) return;

    reviews.forEach((rev) => {
      const authorEl = rev.querySelector('.jdgm-rev__author');
      if (!authorEl) return;
      const authorName = authorEl.textContent.trim();
      const initial = authorName ? authorName.charAt(0).toUpperCase() : '';
      if (!initial) return;

      let icon = rev.querySelector('.jdgm-rev__icon');
      if (!icon) {
        icon = document.createElement('div');
        icon.className = 'jdgm-rev__icon ng-rev-avatar';
        icon.setAttribute('aria-hidden', 'true');
      }

      if (icon.parentElement !== rev || icon !== rev.firstElementChild) {
        rev.insertBefore(icon, rev.firstChild);
      }

      if (icon.textContent.trim() !== initial || icon.childNodes.length !== 1 || icon.firstChild?.nodeType !== 3) {
        while (icon.firstChild) {
          icon.removeChild(icon.firstChild);
        }
        icon.appendChild(document.createTextNode(initial));
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateLayout);
  } else {
    updateLayout();
  }

  const container = document.querySelector('.ng-pdp-reviews-section, .ng-product-reviews') || document.body;
  const observer = new MutationObserver(() => {
    updateLayout();
  });
  observer.observe(container, { childList: true, subtree: true });
})();
